/* eslint-disable react/jsx-closing-tag-location */
import React, { Component } from 'react';

import * as moment from 'moment';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import DateFnsUtils from '@date-io/date-fns';
import FormHelperText from '@material-ui/core/FormHelperText';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { GetDate, setNavigationalWindowObject, deleteNavigationalWindowObject } from '../../AppUtil/AppUtil';
import esLocale from 'date-fns/locale/es';
import enLocale from 'date-fns/locale/en-US';
import { logPageView } from '../../AppUtil/analytics';
import { withTranslation } from 'react-i18next';

const localeMap = {
    'en-US': enLocale,
    'es-ES': esLocale
};
class PaymentMethod extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _disbursalMode: 'ACH',
            _disbursalDate: new Date(),
            _disabled: true,
            _errorMax: '',
            _errorMin: '',
            _textWhenACH: 'app_message.text_when_ach_payment'
        };
    }

    handleDateChange = (date) => {
        this.setState({
            _disbursalDate: date,
            _error: ''
        });
        if (moment(GetDate(date)).diff(GetDate(this.props.maxPaymentDate)) > 0) {
            this.setState({
                _errorMax: 'error_message.date_cant_be_greater_than_first_installment_date'
            });
        } else if (moment(date).diff(moment(), 'day') < 0) {
            this.setState({
                _errorMin: 'error_message.date_cant_be_of_past'
            });
        } else {
            this.setState({
                _errorMin: '',
                _errorMax: ''
            });
        }
    };

    handlePaymentMethod = (e) => {
        this.setState({
            _disbursalMode: e.target.value,
            _textWhenACH: e.target.value === 'ACH' ? 'app_message.text_when_ach_payment' : ''
        });
    };

    handleContinue = () => {
        if (this.state._disbursalMode === 'OFFLINE') {
            if (
                this.state._errorMin !== '' ||
                this.state._errorMax !== '' ||
                moment(this.state._disbursalDate).format() === 'Invalid date'
            ) { return false; }
        }
        const data = {
            payment_mode: this.state._disbursalMode,
            payment_date: this.state._disbursalDate.toISOString()
        };
        this.props.handleContinue(data);
    };

    addRemoveListener = (e) => {
        e.returnValue = '';
    }

    componentDidMount() {
        logPageView('/app/funding-options'); // NOSONAR
        const dataForPopUp = {
            title: 'sweetalert_title.wait',
            messageKey: 'sweetalert.continue_on_payment_method',
            message: {},
            label: ['loan_transfer']
        };
        window.addEventListener('beforeunload', this.addRemoveListener);
        setNavigationalWindowObject(dataForPopUp);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.addRemoveListener);
        deleteNavigationalWindowObject();
    }

    render() {
        const { t, i18n } = this.props;
        return (
            <div className="demo-container mdl-grid">
                <div className="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone" />
                <div className="demo-content mdl-color--white mdl-shadow--4dp content mdl-color-text--grey-800 mdl-cell mdl-cell--8-col radius-20 min-250">
                    <div className="mdl-grid">
                        <div className="mdl-cell mdl-cell--12-col center-items">
                            <h4 className="text-center main-top-heading">{t('work_flows.how_are_you_funding_this_loan')}</h4>
                        </div>
                    </div>
                    <div className="mdl-grid center-items">
                        <div className="mdl-cell mdl-cell--10-col ">
                            <FormControl
                                className={this.props.classes}
                                variant="outlined"
                            >
                                <InputLabel
                                    id="demo-simple-select-outlined-label"
                                    ref={this.inputLabel}
                                >
                                    {t('label.payment_method')}
                                </InputLabel>
                                <Select
                                    fullWidth
                                    id="demo-simple-select-outlined"
                                    labelId="demo-simple-select-outlined-label"
                                    labelWidth={110}
                                    onChange={this.handlePaymentMethod}
                                    value={this.state._disbursalMode}
                                >
                                    <MenuItem value="ACH">{t('label.online_transfer_from_my_bank_account')}</MenuItem>
                                    <MenuItem value="OFFLINE">{t('label.i_will_give_them_cash_check')}</MenuItem>
                                </Select>
                                <p className="ach-text">{this.state._textWhenACH ? t(this.state._textWhenACH) : ''}</p>
                            </FormControl>
                            {this.state._disbursalMode === 'OFFLINE' ? (
                                <>
                                    <MuiPickersUtilsProvider
                                        locale={localeMap[i18n.language] || enLocale}
                                        utils={DateFnsUtils}
                                    >
                                        <KeyboardDatePicker
                                            autoOk
                                            format="MM/dd/yyyy"
                                            fullWidth
                                            id={(()=>{if(this.state._disabled){ return 'date-picker-dialog' }else{ return null}})()}
                                            invalidDateMessage={t('error_message.invalid_date')}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date'
                                            }}
                                            label={t('label.disbursement_loan_date')}
                                            margin="normal"
                                            maxDate={this.props.maxPaymentDate}
                                            maxDateMessage={t(this.state._errorMax)}
                                            minDate={new Date()}
                                            minDateMessage={t(this.state._errorMin)}
                                            onChange={this.handleDateChange}
                                            value={this.state._disbursalDate}
                                        />
                                    </MuiPickersUtilsProvider>
                                    <FormHelperText id="text-red">
                                        {(()=>{if(this.state._error){return t(this.state._error)}else{ return ''}})()}
                                    </FormHelperText>
                                </>
                            ) : null}
                            <div className="mdl-cell mdl-cell--12-col text-center">
                                <button
                                    className="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                                    onClick={this.props.handleBack}
                                    type="button"
                                >
                                    {t('back')}
                                </button>
                                <button
                                    className="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                                    onClick={this.handleContinue}
                                    type="button"
                                >
                                    {t('buttons.continue')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(PaymentMethod);
